import { v4 as uuid } from 'uuid';
import { DateParser, DateUtils, LocaleManager, CursorPhraseUtils } from './utils';
export var dateSuggestionHandler = {
  type: 'date',
  detect: function detect(state, cursorPhrases) {
    var locale = LocaleManager.getSelectedLocale(state);
    var sortedPhrases = CursorPhraseUtils.sortByDescendingRangeLength(cursorPhrases);
    var match = CursorPhraseUtils.findFirstValidDatePhrase(sortedPhrases, locale);
    if (!match || !DateUtils.canInsertDateNode(state, match.phrase.from)) {
      return null;
    }
    return {
      id: uuid(),
      type: 'date',
      from: match.phrase.from,
      to: match.phrase.to,
      metadata: {
        date: match.result.date,
        matchedFormat: match.result.matchedFormat,
        trailingDelimiter: match.result.trailingDelimiter
      },
      isPartial: !match.result.matchedFormat.includes('y')
    };
  },
  createMarkers: function createMarkers(suggestion) {
    var from = suggestion.from,
      to = suggestion.to;
    return [{
      style: 'highlight',
      from: from,
      to: to
    }, {
      style: 'underline',
      from: from,
      to: to
    }];
  },
  createCompletionHint: function createCompletionHint(suggestion) {
    if (!suggestion.isPartial) {
      return null;
    }
    var _suggestion$metadata = suggestion.metadata,
      date = _suggestion$metadata.date,
      matchedFormat = _suggestion$metadata.matchedFormat,
      trailingDelimiter = _suggestion$metadata.trailingDelimiter;
    var formatDelimiter = DateParser.extractDelimiterFromFormat(matchedFormat);
    if (trailingDelimiter && trailingDelimiter === formatDelimiter) {
      return {
        hintText: "".concat(date.getFullYear())
      };
    } else {
      return {
        hintText: "".concat(formatDelimiter).concat(date.getFullYear())
      };
    }
  },
  createReplacement: function createReplacement(suggestion, schema) {
    var date = suggestion.metadata.date;
    var timestamp = DateUtils.getDateOnlyUtcTimestamp(date);
    return schema.nodes.date.create({
      timestamp: String(timestamp)
    });
  }
};